import React from "react";
import { colors } from "../../../../../../../themes/Colors";
import BaseButtons from "../../../../../base-buttons/BaseButtons";
import TextInputField from "../../../../../text-input-field/TextInputField";

const CurrentUserPopUp = ({ display, onCloseClick }) => {
  return (
    <div
      style={{
        position: "absolute",
        height: display ? "100%" : 0,
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: colors.white,
        overflow: "hidden",
        transition: "all 0.3s",
        opacity: display ? 1 : 0,
        bottom: 0,
      }}
    >
      <div style={{ position: "absolute", top: 55, left: 10 }}>
        <BaseButtons
          label={"BACK"}
          borderRadius={8}
          onClick={onCloseClick}
          width={65}
          height={40}
          backgroundColor={colors.orangeDark}
        />
      </div>
      <div
        style={{
          //   position: "absolute",
          marginTop: 62,
          width: "100%",
          display: "flex",
          alignItems: "center",

          textAlign: "center",
          justifyContent: "center",
          fontWeight: "bold",
          fontSize: 20,
          marginBottom: 20,
        }}
      >
        CURRENT USER
      </div>
      <TextInputField mini={true} labelTitle={"NAME"} />
      <div style={{ height: 10 }} />
      <TextInputField mini={true} labelTitle={"CELL NUMBER"} />
      <div style={{ height: 10 }} />
      <TextInputField mini={true} labelTitle={"EMAIL"} />
      <div style={{ height: 40 }} />
      <BaseButtons
        label={"DRIVERS LICENSE"}
        borderRadius={8}
        backgroundColor={colors.greenDark}
        width={"80%"}
      />

      <div style={{ height: 40 }} />
      <BaseButtons
        label={"CALL NOW"}
        borderRadius={8}
        backgroundColor={colors.greenLight}
        width={"80%"}
      />
      <div style={{ height: 20 }} />
      <BaseButtons
        label={"SEND NOTICE"}
        borderRadius={8}
        backgroundColor={colors.greenLight}
        width={"80%"}
      />
    </div>
  );
};

export default CurrentUserPopUp;
